export default __webpack_public_path__ + "static/media/01.a17575a9.jpg";